import {Box} from '@mantine/core';
import type React from 'react';
import {MdFavorite} from 'react-icons/md';
import {
  COLOR_INTERESTS_GRADUATION_END,
  COLOR_INTERESTS_GRADUATION_START,
} from '../../../../config/constants/colorCodes';
import {cn} from '../../../../lib/classname';

type Props = {
  youAreInterested: boolean;
  handleClickInterest: () => void;
};

export const CompanyDetailInterestsPresentation: React.FC<Props> = ({
  youAreInterested,
  handleClickInterest,
}: Props) => {
  return (
    <Box className="p-16 flex justify-between items-center bg-white text-base rounded-16 shadow-card mt-16">
      <Box>
        あなたに興味を持っているようです。私も興味があるとお知らせすると、スカウトが届きやすくなります。
      </Box>
      <button
        type="button"
        className={cn(
          'flex items-center text-white px-16 py-8 rounded-12 gap-4',
          youAreInterested
            ? 'bg-black-3 cursor-not-allowed'
            : 'hover:opacity-80 cursor-pointer',
        )}
        style={{
          background: youAreInterested
            ? ''
            : `linear-gradient(166deg, ${COLOR_INTERESTS_GRADUATION_START} 0%, ${COLOR_INTERESTS_GRADUATION_END} 100%)`,
        }}
        onClick={handleClickInterest}
        disabled={youAreInterested}
      >
        <MdFavorite />
        {youAreInterested ? '送信しました' : '私も興味がある'}
      </button>
    </Box>
  );
};
